import React from 'react';
import { UserAlert } from '../../atoms/alerts';
import { MetricCard } from '../../atoms';
import { PreferredPartner } from '../../molecules';
import { CommentSection, RatingCard, DoughnutGraph, Bargraph } from '../../organisms';
import { commaingNumber } from '../../../../utils';
import { india_map } from '../../../../assets/images';
import WalletUtilizationCommon from './WalletUtilizationCommon';
import Skeleton from 'react-loading-skeleton';
import { OverviewSectionIcon } from '../../../overview/OverviewSectionIcon';

const GymAndFitness = ({ metricObj, commentsObj, utilizationObj, ratingObj, loading, walletUtilizationObj, benefitName }) => {
  const { total_sposored_session, total_session_utilized, coverage, donutGraphData, activeCustomerCount, unique_users, repeat_users, hasCustomerFormSubmissions } = metricObj;
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { partners, activities } = commentsObj;
  const { barlabels, bardata, barBgColors } = utilizationObj;
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;

  return (
    <div>
      <p className='mt-8 text-xs font-semibold uppercase tracking-wider text-gray-500'>Gym bookings</p>
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3'>
        {walletEnable && totalWalletAmount > 0 && (
          <MetricCard
            variant='ds-default'
            icon={<OverviewSectionIcon name='wallet' />}
            loading={loading}
            loaderHeight={120}
            title='Total amount added'
            subTitle='Total amount added for employee and dependent wallet utilization'
            metricValue={`₹${commaingNumber(totalWalletAmount)}`}
            classes='min-w-0 flex-1'
          />
        )}
        <MetricCard
          variant='ds-default'
          icon={<OverviewSectionIcon name='gym' />}
          loading={loading}
          loaderHeight={120}
          title='Total sponsored session'
          subTitle='Sessions allocated under the benefit'
          metricValue={commaingNumber(total_sposored_session)}
          classes='min-w-0 flex-1'
        />
        <MetricCard
          variant='ds-default'
          icon={<OverviewSectionIcon name='gym' />}
          loading={loading}
          loaderHeight={120}
          title='Total sessions utilized'
          subTitle='Sessions booked by employees and dependents'
          metricValue={commaingNumber(total_session_utilized)}
          classes='min-w-0 flex-1'
        />
      </div>

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={activeCustomerCount}/>

      <div className='mt-12 flex flex-col gap-8 lg:flex-row lg:justify-between'>
        <div className='flex min-w-0 flex-1 flex-col lg:mr-4 lg:w-1/2'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>
            Top preferred partners by your employees
          </p>
          <p className='mb-3 text-sm text-gray-600'>
            Ranks partners by how many employees selected them
          </p>
          <PreferredPartner loading={loading} loaderHeight={200} list={partners} header='Partners' classes='h-full' />
        </div>
        <div className='flex min-w-0 flex-1 flex-col lg:w-1/2'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>
            Top preferred activity by your employees
          </p>
          <p className='mb-3 text-sm text-gray-600'>
            Most-booked gym and fitness activities
          </p>
          <PreferredPartner loading={loading} loaderHeight={200} list={activities} header='Activity' classes='h-full' />
        </div>
      </div>
      {hasCustomerFormSubmissions &&
        <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
          *Also includes data from the form submitted by the customer
        </p>
      }

      <div className='mt-12 flex flex-col gap-8 lg:flex-row'>
        <div className='flex flex-col pr-4 lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Ratings and reviews</div>
          <div className='mb-3 text-sm text-gray-600'>
            These ratings are captured after completing the gym & fitness.
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='flex w-full flex-col lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Top comments</div>
          <div className='mb-3 text-sm text-gray-600'>
            These reviews are captured after completing the gym & fitness.
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>
      {hasCustomerFormSubmissions &&
        <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
          *Also includes data from the form submitted by the customer
        </p>
      }

      <div className='mt-12'>
        <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Session wise booking</p>
        <p className='mb-3 text-sm text-gray-600'>Distribution of sessions by type</p>
        <div className='flex flex-col gap-8 lg:flex-row'>
          <div className='flex min-w-0 flex-1 flex-col pr-4 lg:w-2/4'>
            <DoughnutGraph
              loading={loading}
              loaderHeight={200}
              title='Sessions'
              graphData={donutGraphData}
              tooltip_placement='top'
              classes='h-full'
              id='gym'
            />
          </div>

          <div className='flex min-w-0 flex-1 flex-col lg:w-2/4'>
            {loading ? (
              <Skeleton width='100%' height={200} />
            ) : (
              <div className='h-full rounded-xl border border-gray-200 bg-white p-6 shadow-sm'>
                <img src={india_map} alt='india_map' className='mb-4' />
                <p className='mb-1 text-sm text-gray-500'>
                  Your employees can persue fitness with the best fitness expert,
                </p>
                <p className='mb-0 text-sm text-gray-500'>
                  ekincare coverage is across{' '}
                  <span className='font-semibold text-gray-600'>{6000}+ fitness studios PAN India</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='mt-12'>
        <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Utilization based on location</p>
        <p className='mb-3 text-sm text-gray-600'>Booking share by location</p>
      </div>
      <div
        className={
          'mt-0 rounded-xl border border-gray-200 shadow-sm ' +
          (loading ? '' : 'bg-white ') +
          (bardata && bardata.length === 0 ? 'pt-6 ' : '')
        }
      >
        {bardata && bardata.length === 0 && <UserAlert para='Locations data is not available' paraClasses=' font-semibold text-gray-600' imgClasses=' h-5 w-5' classes=' p-4 ml-6 mr-4'/>}
        <Bargraph
          loading={loading}
          loaderHeight={300}
          id='utilizationbargraph'
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='350px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel='Locations'
          yAxesLabel='Utilization percentages'
        />
      </div>
    </div>
  );
};

export default GymAndFitness;
